import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <svg width="200" height="40" viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <text x="0" y="28" fontSize="24" fontWeight="700" fontFamily="Inter, sans-serif">
                <tspan fill="#B91C1C">Multi</tspan>
                <tspan fill="#e8641e">servicios</tspan>
              </text>
              <line x1="0" y1="35" x2="167" y2="35" stroke="#e8641e" strokeWidth="3" />
            </svg>
          </div>

          <div className="header-actions">
            <a href='https://galicia.dspigs.com/' target="_blank" rel="noopener noreferrer" className="btn-link">
              <button className="btn btn-primary cta-button">
                Agendar Asistencia
              </button>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;